var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "billing-moment-select" },
    [
      _c("p", [_vm._v("Modo de facturación:")]),
      _c(
        "v-select",
        {
          attrs: {
            id: "type",
            label: "text",
            options: _vm.billingMoments,
            clearable: false,
          },
          on: { input: _vm.setBillingMoments },
          model: {
            value: _vm.billingMomentSelected,
            callback: function ($$v) {
              _vm.billingMomentSelected = $$v
            },
            expression: "billingMomentSelected",
          },
        },
        [
          _c("span", { attrs: { slot: "no-options" }, slot: "no-options" }, [
            _vm._v("Nada que mostrar."),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }